// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Tool_padding {
        padding: 20px;

        display: flex;
        height: 100%;
        flex-grow: 1;

        justify-content: center;

        overflow: hidden;
}

.Tool_container {
        display: flex;

        gap: 20px;
}

.Tool_partition {
        border-radius: 8px;

        display: flex;
        width: 450px;

        flex-direction: column;

        position: relative;
}

.Tool_inputs {
        border: 1px solid #e4e4e4;
        border-bottom: none;
        border-top-left-radius: 8px;
        border-top-right-radius: 8px;

        background-color: #fff;

        display: flex;
        flex-grow: 1;

        flex-direction: column;

        overflow-y: hidden;
}

.Tool_outputContainer {
        overflow: hidden;
        border-radius: 8px;
        height: 100%;
        width: 100%;
}

.Tool_output_floatingHeader {
        height: 60px;
        width: 100%;
        box-sizing: border-box;

        display: flex;
        align-items: center;
        justify-content: flex-end;
        gap: 10px;

        position: absolute;
        z-index: 1;

        border-top-left-radius: 8px;
        border-top-right-radius: 8px;

        padding: 0 17.5px;
}

.Tool_outputContent {
        display: flex;
        flex-direction: column;

        max-width: 100%;
        height: 100%;

        box-sizing: border-box;

        border: 1px solid #e4e4e4;
        border-radius: 8px;

        overflow-x: hidden;
        overflow-y: auto;

        padding: 10px 20px;

        font-family: "Baskerville";
        font-size: 12px;
        font-weight: 500;

        background: #fef9e1;

        border-radius: 8px;

        text-align: justify;
}

.Tool_outputContent.edit {
        padding: 20px;

        font-family: "Roboto";
        font-size: 12px;

        resize: none;

        width: 100%;
}

ol, ul {
        padding-inline-start: 20px;
}`, "",{"version":3,"sources":["webpack://./src/components/Tool/Tool.css"],"names":[],"mappings":"AAAA;QACQ,aAAa;;QAEb,aAAa;QACb,YAAY;QACZ,YAAY;;QAEZ,uBAAuB;;QAEvB,gBAAgB;AACxB;;AAEA;QACQ,aAAa;;QAEb,SAAS;AACjB;;AAEA;QACQ,kBAAkB;;QAElB,aAAa;QACb,YAAY;;QAEZ,sBAAsB;;QAEtB,kBAAkB;AAC1B;;AAEA;QACQ,yBAAyB;QACzB,mBAAmB;QACnB,2BAA2B;QAC3B,4BAA4B;;QAE5B,sBAAsB;;QAEtB,aAAa;QACb,YAAY;;QAEZ,sBAAsB;;QAEtB,kBAAkB;AAC1B;;AAEA;QACQ,gBAAgB;QAChB,kBAAkB;QAClB,YAAY;QACZ,WAAW;AACnB;;AAEA;QACQ,YAAY;QACZ,WAAW;QACX,sBAAsB;;QAEtB,aAAa;QACb,mBAAmB;QACnB,yBAAyB;QACzB,SAAS;;QAET,kBAAkB;QAClB,UAAU;;QAEV,2BAA2B;QAC3B,4BAA4B;;QAE5B,iBAAiB;AACzB;;AAEA;QACQ,aAAa;QACb,sBAAsB;;QAEtB,eAAe;QACf,YAAY;;QAEZ,sBAAsB;;QAEtB,yBAAyB;QACzB,kBAAkB;;QAElB,kBAAkB;QAClB,gBAAgB;;QAEhB,kBAAkB;;QAElB,0BAA0B;QAC1B,eAAe;QACf,gBAAgB;;QAEhB,mBAAmB;;QAEnB,kBAAkB;;QAElB,mBAAmB;AAC3B;;AAEA;QACQ,aAAa;;QAEb,qBAAqB;QACrB,eAAe;;QAEf,YAAY;;QAEZ,WAAW;AACnB;;AAEA;QACQ,0BAA0B;AAClC","sourcesContent":[".Tool_padding {\n        padding: 20px;\n\n        display: flex;\n        height: 100%;\n        flex-grow: 1;\n\n        justify-content: center;\n\n        overflow: hidden;\n}\n\n.Tool_container {\n        display: flex;\n\n        gap: 20px;\n}\n\n.Tool_partition {\n        border-radius: 8px;\n\n        display: flex;\n        width: 450px;\n\n        flex-direction: column;\n\n        position: relative;\n}\n\n.Tool_inputs {\n        border: 1px solid #e4e4e4;\n        border-bottom: none;\n        border-top-left-radius: 8px;\n        border-top-right-radius: 8px;\n\n        background-color: #fff;\n\n        display: flex;\n        flex-grow: 1;\n\n        flex-direction: column;\n\n        overflow-y: hidden;\n}\n\n.Tool_outputContainer {\n        overflow: hidden;\n        border-radius: 8px;\n        height: 100%;\n        width: 100%;\n}\n\n.Tool_output_floatingHeader {\n        height: 60px;\n        width: 100%;\n        box-sizing: border-box;\n\n        display: flex;\n        align-items: center;\n        justify-content: flex-end;\n        gap: 10px;\n\n        position: absolute;\n        z-index: 1;\n\n        border-top-left-radius: 8px;\n        border-top-right-radius: 8px;\n\n        padding: 0 17.5px;\n}\n\n.Tool_outputContent {\n        display: flex;\n        flex-direction: column;\n\n        max-width: 100%;\n        height: 100%;\n\n        box-sizing: border-box;\n\n        border: 1px solid #e4e4e4;\n        border-radius: 8px;\n\n        overflow-x: hidden;\n        overflow-y: auto;\n\n        padding: 10px 20px;\n\n        font-family: \"Baskerville\";\n        font-size: 12px;\n        font-weight: 500;\n\n        background: #fef9e1;\n\n        border-radius: 8px;\n\n        text-align: justify;\n}\n\n.Tool_outputContent.edit {\n        padding: 20px;\n\n        font-family: \"Roboto\";\n        font-size: 12px;\n\n        resize: none;\n\n        width: 100%;\n}\n\nol, ul {\n        padding-inline-start: 20px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
